import { Checkbox } from 'hb-react/shared/components/formik/components/inputs';

export const Remote = () => (
  <Checkbox
    label={s__('Jobform|This opportunity can be done remotely')}
    name="remote"
  />
);
